import React from "react";
import ReactDOM from "react-dom";
import PubSub from "pubsub-js";
import UserConfirmationModal from './UserConfirmationModal';

import { ReactComponent as Warning } from "../../svgs/warning.svg";

const UserConfirmationPrompt = (message, callback) => {
  const container = document.createElement("div");
  container.setAttribute("custom-confirmation-navigation", "");
  document.body.appendChild(container);

  const onClose = (callbackState, sendMessage) => {
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
    if (callbackState && sendMessage) {
      const parsedMessage = JSON.parse(message);
      PubSub.publish(parsedMessage.topic, parsedMessage.data);
    }
    callback(callbackState);
  };

  const dialog = (
    <UserConfirmationModal
      onConfirmClick={() => {
        onClose(true, true);
      }}
      onCancelClick={() => onClose(true, false)}
      onClose={() => onClose(false, false)}
      open={true}
    />
  );
  // Not my favorite - but only way I could force the render while keeping it in the router family
  ReactDOM.render(dialog, container);
};

export default UserConfirmationPrompt;
